import { Component, OnInit } from '@angular/core';
import { LogisticService, BusinesscoItem, StockplaceItem } from '../../../services/logistic.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Grid } from '../../../core/components/grid/grid.model';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';

@Component({
  selector: 'tt-stock-batch-search',
  templateUrl: './stock-batch-search.component.html',
  styleUrls: ['./stock-batch-search.component.css']
})
export class StockBatchSearchComponent implements OnInit {
    public setting?: Setting;

    public selectListCompanies: BusinesscoItem[] = [];

    public selectListStockPlaces: StockplaceItem[] = [];

    public grid?: GridOptions;

    public searchTextButtons: FormButton[] = [
        { id: 'search', type: 'primary', icon: 'fas fa-search', onClick: () => this.loadGrid() }
    ];

    constructor(private datatask: DataTaskService, private logistic: LogisticService) {

    }

    private async loadSetting() {
        this.setting = (await this.datatask.Post(3414))[0];
    }

    private async loadCompanies() {
        this.selectListCompanies = await this.logistic.getCompanies();
    }

    private async loadStockPlaces() {
        if (!this.setting) return;

        this.selectListStockPlaces = await this.logistic.getStockplaces({ businessco_no: this.setting.businessco_no });
    }

    private loadGrid() {
        if (!this.setting) return;

        if (!this.grid) {
            this.grid = new Grid()
                .setRememberId('w_stockbatchsearch_stockbatch_grid')
                .setLoadDataFunction({
                    method: 3415,
                    parameters: this.setting
                })
                .setKendoConfig({ height: '100%' })
                .setToolbar({ wrapping: true });
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    public searchItems() {
        this.loadGrid();
    }

    public onChanged(_: string, id: keyof Setting) {
        if (!this.setting) return;

        switch (id) {
            case 'businessco_no':
                this.loadStockPlaces();
                break;
            case 'stockplace_id':
                this.loadGrid();
                break;
            case 'searchtext':
                if (this.setting.searchtext === '') this.loadGrid();
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadCompanies();
        this.loadStockPlaces();
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    businessco_no: string;
    stockplace_id: string;
    searchtext: string;
    show_setting: string;
}
